import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';
import type { Snippet } from '../../../../../shared/snippets';

import styles from './Header.module.less';

type Props = {
  /**
   * The snippet currently being displayed in the drawer.
   */
  snippet: Snippet;
};

/**
 * The top header section for the SnippetsDrawer
 */
const SnippetsDrawerHeader: VoidFunctionComponent<Props> = ({ snippet }) => {
  return (
    <header className={styles.header}>
      <div className={styles.headerRow}>
        <span className={styles.icon}>
          <Icon icon={icons.receipt} />
        </span>
        <span className={styles.packageName}>
          {snippet.package}
        </span>
        <span className={styles.version}>
          {snippet.version}
        </span>
      </div>
      <div className={styles.snippetsCount}>
        {snippet.matchCount} snippets match to this package
      </div>
    </header>
  );
};

export default SnippetsDrawerHeader;
